module.exports = __webpack_public_path__ + "media/images/career_camp/2023/stats_illustration_2-9247adcddd9194e74b8b8a6a84ef5aa9.svg";